// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tools-container {
  width: 81.7%;
  height: 90vh;
  margin-left: 18%;
}
@media (max-width: 1024px) {
  .tools-container {
    height: 95.6vh;
    margin-left: 28%;
  }
}
.tools-container .image-container {
  justify-content: flex-end;
  width: 44%;
  height: 81.7vh;
  position: fixed;
  right: 0px;
}
@media (max-width: 1024px) {
  .tools-container .image-container {
    width: 50%;
    height: 90.7vh;
  }
}

.image-opacity {
  opacity: 0.1;
}`, "",{"version":3,"sources":["webpack://./src/components/Tools/style.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,YAAA;EACA,gBAAA;AACJ;AAAI;EAJJ;IAKQ,cAAA;IACA,gBAAA;EAGN;AACF;AAFI;EACI,yBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;AAIR;AAFQ;EAPJ;IAQQ,UAAA;IACA,cAAA;EAKV;AACF;;AADA;EACI,YAAA;AAIJ","sourcesContent":[".tools-container{\r\n    width:81.7%;\r\n    height:90vh;\r\n    margin-left:  18%;\r\n    @media (max-width:1024px) {\r\n        height: 95.6vh;\r\n        margin-left: 28%;\r\n    }\r\n    .image-container{\r\n        justify-content: flex-end;\r\n        width: 44%;\r\n        height: 81.7vh;\r\n        position: fixed;\r\n        right:0px;\r\n\r\n        @media (max-width:1024px) {\r\n            width:50%;\r\n            height: 90.7vh;\r\n        }\r\n    }\r\n}\r\n\r\n.image-opacity {\r\n    opacity: 0.1;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
